// /notifications/mark-read	标记通知为已读

import { ResponseDTO } from '@/types';
import request from '@/utils/request';

export function markNotificationAsRead(id: number): Promise<number> {
  return request
    .post<number, ResponseDTO<number>, { notificationIds: number[] }>(`/notifications/mark-read`, {
      notificationIds: [id],
    })
    .then((res) => res.data);
}
